import _orderBy from 'lodash/orderBy';
import { createSelector } from 'reselect';
const getFlowLanguages = (state) => state.flowLanguages.languages;
export const getLastUsedEmailIntegration = (state) => state.settings.personal.lastUsedEmailIntegration;
const getQueues = (state) => state.settings.queues.queues;
const getQueuesAsyncStatus = (state) => state.settings.queues.asyncStatus;
const getTemplateList = (state) => state.settings.templates.templatesList;
/* SELECTORS */
export const selectFlowLanguagesSorted = createSelector(getFlowLanguages, (languages) => _orderBy(languages, [(language) => language.label.toLowerCase()], 'asc'));
export const selectSortedQueuesByName = createSelector(getQueues, (queues) => _orderBy(queues, [(queue) => queue.name.toLowerCase()], ['asc']));
export const selectQueueState = createSelector([selectSortedQueuesByName, getQueuesAsyncStatus], (queues, asyncStatus) => ({
    queues,
    asyncStatus,
}));
export const selectQuickResponseTemplates = createSelector(getTemplateList, (templatesList) => templatesList.filter((t) => t.type === 'quick_response'));
export const selectSortedQueuesByPriorityAndName = createSelector(getQueues, (queues) => _orderBy(queues, [
    (queue) => queue.priority,
    (queue) => queue.name.toLowerCase(),
], ['asc', 'asc']));
